(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-cinema-blog"] && !Shopify.designMode) return;
  try {
    
    (() => {
      document.querySelectorAll('.ss-home-cinema').forEach(root => {
      const tabs = [...root.querySelectorAll('.layout-tab')];
      const layers = [...root.querySelectorAll('[data-layout-layer]')];
      const legends = [...root.querySelectorAll('[data-plan-legend]')];
      const title = root.querySelector('#planTitle');
      const note = root.querySelector('#planDescription');

      function showLayout(tab, moveFocus = false) {
        const key = tab.dataset.layout;
        tabs.forEach(item => item.setAttribute('aria-selected', String(item === tab)));
        layers.forEach(layer => layer.classList.toggle('active', layer.dataset.layoutLayer === key));
        legends.forEach(legend => legend.classList.toggle('active', legend.dataset.planLegend === key));
        title.textContent = tab.dataset.title;
        note.textContent = tab.dataset.note;
        if (moveFocus) tab.focus();
      }

      tabs.forEach((tab, index) => {
        tab.setAttribute('aria-controls', 'placementDiagram');
        tab.addEventListener('click', () => showLayout(tab));
        tab.addEventListener('keydown', event => {
          const keys = ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          showLayout(tabs[next], true);
        });
      });
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inbox-footer-swap"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll(
      '[data-ss-inbox-footer-hide]:not([data-ss-inbox-initialized])'
    );

    roots.forEach((root) => {
      root.dataset.ssInboxInitialized = 'true';

      const footer = document.querySelector('footer');
      if (!footer) return;

      let footerVisible = false;
      let inboxHost;
      let inboxButton;
      let hostObserver;
      let buttonObserver;
      let mountObserver;

      const inboxIsOpen = () => {
        return (
          inboxHost?.getAttribute('is-open') === 'true' ||
          inboxButton?.getAttribute('aria-expanded') === 'true'
        );
      };

      const sync = () => {
        if (!inboxHost) return;

        inboxHost.classList.toggle(
          'ss-inbox-footer-hidden',
          footerVisible && !inboxIsOpen()
        );
      };

      const connectInbox = () => {
        const nextHost = document.querySelector('#ShopifyChat');
        const nextButton = nextHost?.shadowRoot?.querySelector(
          '[data-spec="toggle-button"]'
        );

        if (!nextHost || !nextButton) return false;
        if (nextHost === inboxHost && nextButton === inboxButton) return true;

        hostObserver?.disconnect();
        buttonObserver?.disconnect();

        inboxHost = nextHost;
        inboxButton = nextButton;

        hostObserver = new MutationObserver(sync);
        hostObserver.observe(inboxHost, {
          attributes: true,
          attributeFilter: ['is-open', 'style', 'class']
        });

        buttonObserver = new MutationObserver(sync);
        buttonObserver.observe(inboxButton, {
          attributes: true,
          attributeFilter: ['aria-expanded']
        });

        sync();
        return true;
      };

      const footerObserver = new IntersectionObserver(
        ([entry]) => {
          footerVisible = entry.isIntersecting;
          connectInbox();
          sync();
        },
        {
          threshold: 0,
          rootMargin: '0px 0px -4% 0px'
        }
      );

      footerObserver.observe(footer);

      if (!connectInbox()) {
        mountObserver = new MutationObserver(() => {
          if (connectInbox()) {
            mountObserver.disconnect();
          }
        });

        mountObserver.observe(document.documentElement, {
          childList: true,
          subtree: true
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-review-screening-room"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-screening-room')) {
    customElements.define(
      'review-screening-room',
      class ReviewScreeningRoom extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';

          this.stage = this.querySelector('.review-room__stage');
          this.indexContainer = this.querySelector('[data-review-index]');
          this.rebuildIndex();

          this.onBlockSelect = (event) => {
            const selectedBlock = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
            const panel = selectedBlock?.matches('[data-review-panel]')
              ? selectedBlock
              : selectedBlock?.closest('[data-review-panel]');
            if (panel) this.activate(panel.dataset.blockId, false);
          };

          document.addEventListener('shopify:block:select', this.onBlockSelect);

          if (this.stage) {
            this.stageObserver = new MutationObserver(() => {
              window.clearTimeout(this.rebuildTimer);
              this.rebuildTimer = window.setTimeout(() => this.rebuildIndex(), 0);
            });
            this.stageObserver.observe(this.stage, { childList: true, subtree: true });
          }
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          this.stageObserver?.disconnect();
          window.clearTimeout(this.rebuildTimer);
        }

        rebuildIndex() {
          if (!this.indexContainer) return;

          const activePanel = this.querySelector('[data-review-panel].is-active');
          const activeBlockId = activePanel?.dataset.blockId;
          this.panels = Array.from(this.querySelectorAll('[data-review-panel]'));
          const templates = this.panels
            .map((panel) => panel.querySelector('template[data-review-index-template]'))
            .filter(Boolean);

          this.indexContainer.replaceChildren();
          templates.forEach((template, index) => {
            const fragment = template.content.cloneNode(true);
            const number = fragment.querySelector('[data-review-index-number]');
            if (number) number.textContent = String(index + 1).padStart(2, '0');
            this.indexContainer.append(fragment);
          });

          this.tabs = Array.from(this.indexContainer.querySelectorAll('[data-review-tab]'));
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.activate(tab.dataset.target, true));
            tab.addEventListener('keydown', (event) => this.handleTabKeydown(event, index));
          });

          this.querySelectorAll('[data-media-shell]').forEach((shell) => this.preparePlayer(shell));

          const retainedPanel = this.panels.find((panel) => panel.dataset.blockId === activeBlockId);
          const nextBlockId = retainedPanel?.dataset.blockId || this.panels[0]?.dataset.blockId;
          if (nextBlockId) this.activate(nextBlockId, false);
        }

        preparePlayer(shell) {
          const video = shell.querySelector('video');
          const frame = shell.querySelector('iframe');
          const initialPlay = shell.querySelector('[data-initial-play]');
          if ((!video && !frame) || shell.dataset.controlsReady === 'true') return;
          shell.dataset.controlsReady = 'true';

          const markStarted = () => {
            shell.classList.add('has-started');
            if (initialPlay) initialPlay.hidden = true;
          };

          initialPlay?.addEventListener('click', () => {
            markStarted();
            if (video) {
              video.controls = true;
              video.play().catch(() => {});
              return;
            }

            frame?.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            frame?.contentWindow?.postMessage('{"method":"play"}', '*');
          });

          if (!video) return;

          video.controls = false;
          const showControls = () => {
            video.controls = true;
            shell.removeAttribute('tabindex');
          };
          const hideControls = (event) => {
            if (event?.type === 'pointerleave' && event.pointerType !== 'mouse') return;
            if (!video.paused || shell.matches(':focus-within')) return;
            video.controls = false;
            shell.tabIndex = 0;
          };

          shell.tabIndex = 0;
          shell.addEventListener('pointerenter', showControls);
          shell.addEventListener('pointerleave', hideControls);
          shell.addEventListener('pointerdown', showControls);
          shell.addEventListener('focusin', showControls);
          shell.addEventListener('focusout', hideControls);
          video.addEventListener('play', () => {
            markStarted();
            showControls();
          });
        }

        activate(blockId, moveFocus) {
          this.panels.forEach((panel) => {
            const active = panel.dataset.blockId === blockId;
            panel.hidden = !active;
            panel.classList.toggle('is-active', active);
            panel.setAttribute('aria-hidden', active ? 'false' : 'true');
            if (!active) this.resetMedia(panel);
          });

          this.tabs.forEach((tab) => {
            const active = tab.dataset.target === blockId;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
            if (active && moveFocus) tab.focus({ preventScroll: true });
          });
        }

        resetMedia(panel) {
          panel.querySelectorAll('video').forEach((video) => {
            video.pause();

            const rewind = () => {
              try {
                video.currentTime = 0;
              } catch (error) {
                // The media metadata is not available yet; it will already begin at zero.
              }
            };

            if (video.readyState > 0) rewind();
            else video.addEventListener('loadedmetadata', rewind, { once: true });
          });

          panel.querySelectorAll('iframe').forEach((frame) => {
            frame.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            frame.contentWindow?.postMessage('{"event":"command","func":"seekTo","args":[0,true]}', '*');
            frame.contentWindow?.postMessage('{"method":"pause"}', '*');
            frame.contentWindow?.postMessage('{"method":"setCurrentTime","value":0}', '*');
          });
        }

        handleTabKeydown(event, index) {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;

          this.activate(this.tabs[nextIndex].dataset.target, true);
          this.tabs[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
